<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/w17xLR/tc-custom/9781429933889.jpg?1718106014698" alt="This image is the cover for the book China's First Emperor and His Terracotta Warriors"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">China's First Emperor and His Terracotta Warriors
      </h1>
      <p class="bookDescription body article font2">
        <p>Unifier or destroyer, law-maker or tyrant? China's First Emperor (258-210 BC) has been the subject of debate for over 2,000 years. He gave us the name by which China is known in the West and, by his unification or elimination of six states, he created imperial China. He stressed the rule of law but suppressed all opposition, burning books and burying scholars alive. His military achievements are reflected in the astonishing terracotta soldiers—a veritable buried army—that surround his tomb, and his Great Wall still fascinates the world.<br/><br/>Despite his achievements, however, the First Emperor has been vilified since his death. <i>China's First Emperor and His Terracotta Warriors </i>describes his life and times and reflects the historical arguments over the real founder of China and one of the most important men in Chinese history.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Frances Wood
      </h2>
      
      <p class="authorDescription body article"><P>FRANCES WOOD is head of the Chinese department at the British Library. She is also the author of multiple books, including, <I>Did Marco Polo Go to </I><I>China</I><I>?, No Dogs and Not Many Chinese: A History of the Treaty Ports, </I>and<I> The </I><I>Silk Road</I><I>.</I></P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?bc8798c4